import { stringify, parse } from "flatted";
import { canUseCookie } from "./cookie";

export function getItem<T>(key: string, toJSON: boolean = true): T | null {
  /** need to check first. local-storage Access is denied when disabling cookie */
  if (!canUseCookie()) {
    return null;
  }
  try {
    if (typeof window === "undefined" || !sessionStorage) return null;

    // @ts-ignore
    const rawData = sessionStorage.getItem(key) || "";
    if (!rawData) {
      return null;
    }

    return toJSON ? parse(rawData) : rawData;
  } catch (err) {
    console.error(`sessionStorage getItem ${key} error`, err);
  }
  return null;
}

export function setItem<T>(key: string, item: T) {
  /** need to check first. local-storage Access is denied when disabling cookie */
  if (!canUseCookie()) {
    return null;
  }
  try {
    if (typeof window === "undefined" || !sessionStorage) return null;
    const value = typeof item === "object" ? stringify(item) : (item as string);
    return sessionStorage.setItem(key, value);
  } catch (err) {
    console.error(`sessionStorage setItem ${key} error`, err);
  }
}

export function removeItem(key: string) {
  if (typeof window === "undefined" || !sessionStorage) return null;

  try {
    return sessionStorage.removeItem(key);
  } catch (err) {
    console.error(`sessionStorage remove ${key} error`, err);
  }
}
